import angular from 'angular';
import template from './template.html';
import './style.scss';
import logger from '../../../shared/logger';
import { positionStatuses } from '../../../constants/position';

export class PositionOnBoardingTimeline {
    positionData = {};
    milestones = {};
    canViewMilestone = false;

    /* @ngInject */
    constructor(
        $filter,
        permissions,
        PositionService,
        NotificationService,
        $timeout,
    ) {
        this.$filter = $filter;
        this.permissions = permissions;
        this.PositionService = PositionService;
        this.NotificationService = NotificationService;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.canViewMilestone = this.permissions.isTalenyaUser() || this.permissions.isTalentExpertUser();
    }

    $onChanges() {
        const { positionData } = this;

        this.setupMilestones(positionData);
    }

    getLastDateOfEventType(events, eventType) {
        if (!events && events.length) {
            return null;
        }

        const sorted = Object.values(events)
            .filter(item => item.eventType === eventType)
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

        if (sorted.length === 0) {
            return null;
        }

        return sorted[0].timestamp;
    }

    getStatusDate(status) {
        const dateSource = this.$filter('getJobDateByStatus')(this.positionData.status, status);

        if (!dateSource) {
            return null;
        }
        const date = new Date(dateSource);

        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date;
    }

    getPostedDate(milestones = {}) {
        const isTalentExpertOrTalenyaUser = this.permissions.isTalenyaUser() || this.permissions.isTalentExpertUser();

        if (milestones.postedDate) {
            return milestones.postedDate;
        }

        if (this.positionData.status.current === positionStatuses.DRAFT && isTalentExpertOrTalenyaUser) {
            return null;
        }

        const readyDate = this.getStatusDate(positionStatuses.READY);

        if (readyDate) {
            return readyDate;
        }

        return this.getStatusDate(positionStatuses.ACTIVE);
    }

    getScrappingDate(milestones = {}, events) {
        const scrapeCompletedDate = this.getLastDateOfEventType(events, 'scrape_completed');

        return milestones.scrappingDate || scrapeCompletedDate;
    }

    getFirstInsightReportDate(milestones = {}, events) {
        const insightSendDate = this.getLastDateOfEventType(events, 'insight_sent');

        return milestones.firstInsightReportDate || insightSendDate;
    }

    getFeedbackReceivedDate(milestones = {}, events) {
        const feedbackRatingCompletedDate = this.getLastDateOfEventType(events, 'feedback_rating_completed');

        return milestones.feedbackReceivedDate || feedbackRatingCompletedDate;
    }

    setupMilestones(positionData) {
        const { milestones, events } = positionData;
        const onBoardingDate = milestones && milestones.onBoardingDate;

        this.milestones = {
            postedDate: this.getPostedDate(milestones),
            scrappingDate: this.getScrappingDate(milestones, events),
            firstInsightReportDate: this.getFirstInsightReportDate(milestones, events),
            feedbackReceivedDate: this.getFeedbackReceivedDate(milestones, events),
            onBoardingDate,
        };
    }

    onDateChange(date, milestoneName) {
        const readyDate = this.getStatusDate('Ready');
        const isDateMoreOrEqualToReadyDate = (date >= readyDate);

        if (!isDateMoreOrEqualToReadyDate && date) {
            this.NotificationService.error('ONBORADING_TIMELINE_DATE_ERROR');

            return;
        }

        this.updatePositionMilestone(milestoneName, date);
    }

    async updatePositionMilestone(milestoneNameKey, value) {
        const { positionData, milestones } = this;
        const currentPositionMilestones = {
            ...milestones,
            [milestoneNameKey]: value,
        };
        const processedPositionMilestones = Object.keys(currentPositionMilestones).reduce((targetMilestones, milestoneNameKey) => {
            const positionMilestone = currentPositionMilestones[milestoneNameKey];

            if (!positionMilestone) {
                return {
                    ...targetMilestones,
                    [milestoneNameKey]: null,
                };
            } else {
                return {
                    ...targetMilestones,
                    [milestoneNameKey]: positionMilestone,
                };
            }
        }, {});

        try {
            const positionToSave = {
                ...positionData,
                milestones: processedPositionMilestones,
            };
            this.milestones = currentPositionMilestones;

            await this.PositionService.updatePosition(positionData._id, positionToSave);

            this.positionData = positionToSave;
            this.$timeout(() => this.setupMilestones(this.positionData));
        } catch (error) {
            logger.error(error);
            this.NotificationService.error('JOB_MILESTONE_SET_ERROR');
        }
    }
}

export const PositionOnBoardingTimelineConfiguration = {
    template,
    bindings: {
        positionData: '=',
    },
    controller: PositionOnBoardingTimeline,
    controllerAs: 'positionOnBoardingTimelineCtrl',
};

angular
    .module('TALENYA-FE')
    .component('positionOnBoardingTimeline', PositionOnBoardingTimelineConfiguration);
